<div class="amend-superseded-screen">
  <div class="options">
    <label class="option">
      <input type="radio" name="amend-mode" value="amend" [checked]="mode === 'amend'" (change)="setMode('amend')">
      <span>Amendments Returns</span>
    </label>
    <label class="option">
      <input type="radio" name="amend-mode" value="superseded" [checked]="mode === 'superseded'" (change)="setMode('superseded')">
      <span>Superseded Returns</span>
    </label>
  </div>

  <div class="actions">
    <button class="cancel-button" type="button" [disabled]="submitting" (click)="create()">
      Create New Return
      @if (submitting) {
<span><i class="fa fa-spinner fa-spin"></i></span>
}
    </button>
  </div>
</div>

<!--
  Confirmation modal — port of legacy `showConfirmDialog()` in
  `AmendSupersededReturnsController` (ui/app/components/efile/efileElements/
  EfileElementsController.js L4787). Replaces the AngularJS
  `app/templates/modals/confirm-action.html` $uibModal with the shared
  Angular `gtw-confirmation-modal` component.
-->
@if (showConfirm) {
<gtw-confirmation-modal
 
  [config]="confirmConfig"
  [visible]="false"
  (confirmed)="onConfirm()"
  (cancelled)="onCancel()"
  (closed)="onCancel()">
</gtw-confirmation-modal>
}
